<template>
  <div
    class="modal modal-budget fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">
            {{ title }}
          </h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Project Name</label>
            <input
              name="name"
              v-model="newBudget.name"
              type="text"
              class="form-control"
              data-vv-validate-on="input|blur"
              data-vv-as="name"
              v-validate="'required'"
            />
            <help-block field="name" />
          </div>

          <div class="row">
            <div class="col-6 mb-3">
              <label class="control-label">Billing Type</label>
              <multiselect
                :show-labels="false"
                v-model="newBudget.billing_type"
                :options="billingTypes"
                v-validate="'required'"
                data-vv-name="type"
              ></multiselect>
              <help-block field="type" />
            </div>

            <div class="col-6 mb-3">
              <label class="control-label">Start Date</label>
              <input
                name="start_date"
                v-model="newBudget.start_date"
                type="date"
                class="form-control"
              />
              <help-block field="start_date" />
            </div>
          </div>

          <div class="mb-3">
            <label class="control-label">Select Client</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fal fa-fw fa-building"></i>
              </span>
              <multiselect
                :show-labels="false"
                v-model="client"
                :options="clients"
                label="company"
                track-by="id"
                placeholder=""
                v-validate="'required'"
                data-vv-name="client"
                @select="clientSelected"
              >
                <template slot="beforeList">
                  <a
                    href=""
                    style="padding:10px;"
                    data-bs-toggle="modal"
                    data-bs-target=".modal-client-create"
                  >
                    Add New Client
                  </a>
                </template>
              </multiselect>
            </div>
            <help-block field="client" />
          </div>

          <div class="mb-3" v-if="client">
            <label class="control-label">Select Contact</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fal fa-fw fa-address-card"></i>
              </span>
              <multiselect
                :show-labels="false"
                v-model="contact"
                :options="contacts"
                label="name"
                track-by="id"
                placeholder=""
                v-validate="'required'"
                data-vv-name="contact"
                @select="contactSelected"
              >
                <template slot="beforeList">
                  <a
                    href=""
                    style="padding:10px;"
                    data-bs-toggle="modal"
                    data-bs-target=".modal-contact-create"
                  >
                    Add Contact
                  </a>
                </template>
                <template slot="singleLabel" slot-scope="props">
                  <span class="option__title">{{ props.option.name }}</span>
                  <span class="option__small">{{ props.option.email }}</span>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                    <span class="option__small">{{ props.option.email }}</span>
                  </div>
                </template>
              </multiselect>
            </div>
            <help-block field="contact" />
          </div>

          <div class="mb-3">
            <label class="control-label">Linked Opportunity</label>
            <multiselect
              v-model="opportunity"
              :options="opportunities"
              label="formatted_name"
              track-by="id"
              :show-labels="false"
              placeholder="Select Opportunity (Optional)"
              @select="opportunitySelected"
              @remove="opportunityRemoved"
            ></multiselect>
          </div>

          <div class="mb-3">
            <label class="control-label">Owner</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fal fa-fw fa-user"></i>
              </span>
              <multiselect
                :show-labels="false"
                v-model="user"
                :options="users"
                label="name"
                track-by="id"
                placeholder="Select Owner"
                v-validate="'required'"
                data-vv-name="user"
                @select="ownerSelected"
              ></multiselect>
            </div>
            <help-block field="user" />
          </div>

          <div class="mb-3">
            <label class="control-label">Default Account Code for Invoices</label>
            <multiselect
              :show-labels="false"
              v-model="accountCode"
              :options="accountCodes"
              label="name"
              track-by="id"
              placeholder="Select Account Code"
              v-validate="'required'"
              data-vv-name="account_code"
              data-vv-as="account code"
              @select="accountCodeSelected"
            ></multiselect>
            <help-block field="account_code" />
          </div>

          <div class="mb-3">
            <label class="control-label">Select Yodiz Projects</label>
            <small class="form-text text-muted d-block mb-1">Any time added in Yodiz against these projects will be included.</small>
            <multiselect
              :show-labels="false"
              :multiple="true"
              v-model="selectedYodizProjects"
              :options="projects"
              label="text"
              track-by="id"
              placeholder=""
              @select="projectSelected"
              @remove="projectRemoved"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.text }}</span>
                  <small v-if="props.option.yodiz_id"> - yodiz</small>
                </div>
              </template>
            </multiselect>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button @click="handleSaveBudget" class="btn btn-rounded btn-primary">Save</c-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.invalid-feedback {
  display: inline-block;
}
</style>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { notify } from 'utils'
import { cloneDeep } from 'lodash'
import Multiselect from 'vue-multiselect'
import { CModal } from '@chameleon/chameleon-vue'

export default {
  $_veeValidate: {
    validator: 'new' // give me my own validator scope.
  },

  extends: CModal,

  props: ['title', 'budget'],

  components: {
    Multiselect
  },

  data () {
    return {
      newBudget: {},
      billingTypes: ['Pre', 'Post'],
      accountCodes: [
        { id: 41990, name: 'Scoping Requirements Income' },
        { id: 41795, name: 'Cloud Application Development - Hourly' },
        { id: 41771, name: 'Mobile Application Development (Per Hour)' },
        { id: 41796, name: 'Cloud App Development Hourly - Project Team' }
      ],
      client: null,
      contact: null,
      user: null,
      opportunity: null,
      accountCode: null,
      selectedYodizProjects: []
    }
  },

  mounted () {
    this.getClients()
    this.getUsers()
    this.getProjects()
    this.getOpportunities()

    this.addEventListener('open', () => {
      this.newBudget = cloneDeep(this.budget)
      this.newBudget.yodiz_projects = (this.newBudget.yodiz_projects || []).map(({ id }) => ({ id }))

      this.selectedYodizProjects = (this.budget.yodiz_projects || []).map(({ id, title, yodiz_id }) => ({ id, text: title, yodiz_id }))
      this.accountCode = this.accountCodes.find(({ id }) => id === parseInt(this.newBudget.account_code)) || null

      if (this.newBudget.client_id) {
        this.client = this.getClientById(this.newBudget.client_id)

        this.getContacts(this.newBudget.client_id).then(() => {
          this.contact = this.getContactById(this.newBudget.contact_id)
        })
      }

      if (this.newBudget.opportunity_id) {
        this.getOpportunities().then(() => {
          this.opportunity = this.getOpportunityById(this.newBudget.opportunity_id)
        })
      }

      if (this.newBudget.user_id) {
        this.user = this.getUserById(this.newBudget.user_id)
      }
    })

    this.$bus.$on('newClientCreated', this.onClientCreated)
    this.$bus.$on('newContactCreated', this.onContactCreated)
  },

  beforeDestroy () {
    this.$bus.$off('newClientCreated', this.onClientCreated)
    this.$bus.$off('newContactCreated', this.onContactCreated)
  },

  computed: {
    ...mapState('contacts', ['contacts']),
    ...mapState('clientsList', ['clients']),
    ...mapState('users', ['users']),
    ...mapState('projectsList', ['projects']),
    ...mapState('opportunityList', ['opportunities']),
    ...mapGetters('clientsList', { getClientById: 'getById' }),
    ...mapGetters('contacts', { getContactById: 'getById' }),
    ...mapGetters('users', { getUserById: 'getById' }),
    ...mapGetters('opportunityList', { getOpportunityById: 'getById' })
  },

  methods: {
    ...mapActions('budget', ['addSingle', 'updateSingle']),
    ...mapActions('clientsList', ['getClients']),
    ...mapActions('users', ['getUsers']),
    ...mapActions('contacts', ['getContacts']),
    ...mapActions('projectsList', { getProjects: 'getList' }),
    ...mapActions('opportunityList', ['getOpportunities']),

    onClientCreated (clientId) {
      this.getClients().then(() => {
        this.client = this.getClientById(clientId)
        this.newBudget.client_id = clientId

        // Auto select first contact when new client is created
        this.getContacts(clientId).then(() => {
          if (this.contacts.length) {
            this.contact = this.getContactById(this.contacts[0].id)
            this.newBudget.contact_id = this.contact.id
          }
        })
      })
    },

    onContactCreated (contactId) {
      this.getContacts(this.newBudget.client_id).then(() => {
        this.contact = this.getContactById(contactId)
        this.newBudget.contact_id = this.contact.id
      })
    },

    clientSelected (selected) {
      this.newBudget.client_id = selected.id
      // Ensure no contact is selected from a previous client selection
      this.contact = null
      this.newBudget.contact_id = null
      this.getContacts(selected.id)
    },

    contactSelected (selected) {
      this.newBudget.contact_id = selected.id
    },

    ownerSelected (selected) {
      this.newBudget.user_id = selected.id
    },

    accountCodeSelected (selected) {
      this.newBudget.account_code = selected.id
    },

    opportunitySelected (selected) {
      this.newBudget.opportunity_id = selected.id
    },

    opportunityRemoved () {
      this.newBudget.opportunity_id = null
    },

    projectSelected (selected) {
      this.newBudget.yodiz_projects.push({ id: selected.id })
    },

    projectRemoved (removed) {
      this.newBudget.yodiz_projects = this.newBudget.yodiz_projects.filter(({ id }) => id !== removed.id)
    },

    async handleSaveBudget () {
      if (!(await this._validate())) {
        notify.error('Form validation failed, please check your inputs and try again.')
        return Promise.reject()
      }

      const request = this.newBudget.id
        ? this.updateSingle({ id: this.newBudget.id, payload: this.newBudget })
        : this.addSingle(this.newBudget)

      return request.then((response) => {
        if (this.newBudget.id) {
          notify.success('Budget successfully updated.')
          this.$emit('updated', response.data)
        } else {
          // Wait until the modal has hidden as the parent navigates away on create,
          // destroying the modal before bootstrap can remove the backdrop
          this.$once('closed', () => this.$emit('created', response.data))
        }

        this.close()
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          notify.error('Form validation failed, please check your inputs and try again.')
        } else {
          console.error(error)
          notify.error('Failed to save budget, please try again.')
        }
      })
    }
  }
}
</script>
